import { Link } from "react-router-dom";
import styles from "./401.module.css";

const Unauthorized = () => {

  return (<div className={`${styles.container}`}>
    <div className={`${styles.card}`}>
      <h1>401</h1>
      <h2>Unauthorized Access</h2>
      <p>You have no access for this page.</p>
      <Link to={"/dashboard"} className={`${styles.btn}`}>Go Back Dashboard</Link>
    </div>
  </div>);
}

export default Unauthorized;